import type { CSSProperties, ReactNode } from 'react'

export interface FilterPillProps {
  active: boolean
  onClick?: () => void
  /** Background + border color when active. Defaults to var(--brand-primary).
   *  Pass a category color (e.g. catOf(type).color) for per-category filter pills. */
  activeColor?: string
  children: ReactNode
  style?: CSSProperties
}

/** Interactive toggle pill button for filter UIs. */
export function FilterPill({
  active,
  onClick,
  activeColor = 'var(--brand-primary)',
  children,
  style,
}: FilterPillProps) {
  return (
    <button
      onClick={onClick}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 7,
        fontFamily: 'var(--font-body)',
        fontSize: 13.5,
        fontWeight: 600,
        padding: '7px 13px',
        borderRadius: 'var(--radius-pill)',
        cursor: 'pointer',
        border: `1.5px solid ${active ? activeColor : 'var(--border-soft)'}`,
        background: active ? activeColor : 'var(--surface-card)',
        color: active ? 'var(--paper-0)' : 'var(--ink-1)',
        ...style,
      }}
    >
      {children}
    </button>
  )
}
